export class AlertMessage {
    static showMessage(message) {
        $('main.main.page .errors').remove();
        
        const errorTemplate = `
            <div class="errors">
                ${message}
            </div>
        `;
        $('main.main.page').append(errorTemplate);

        setTimeout(() => {
            $('main.main.page .errors').remove();
        }, 5000);
    }
}